export default __webpack_public_path__ + "static/Monetise-a20f42bb8229ba46b46403dd68cbb666.svg";